export const AREA_CAPABILITIES = {
  projects: 'projects.read',
  /** Pre-project bid workspaces at /tenders. Per-space access is a separate, server-side ACL. */
  tender: 'tender.read',
  finance: 'finance.read',
  financeMaster: 'finance.master.read',
  hr: 'hr.read',
  qhse: 'qhse.read',
  survey: 'survey.read',
  drilling: 'drilling.read',
  recording: 'recording.read',
  basecamp: 'basecamp.read',
  operations: 'operations.read',
  admin: 'admin.read',
  /** Access Developer hub and /platform APIs — allowlisted usernames only (see ACCESS_DEVELOPER_USERNAMES). */
  platformDeveloper: 'platform.developer',
  inventory: 'inventory.read',
  procurement: 'procurement.read',
  catering: 'catering.read',
};

/** For screens shared across acquisition areas (budget editor, management dailies). */
export const ANY_AREA_BUDGET_OR_DAILY = [
  AREA_CAPABILITIES.survey,
  AREA_CAPABILITIES.drilling,
  AREA_CAPABILITIES.recording,
  AREA_CAPABILITIES.basecamp,
  AREA_CAPABILITIES.finance,
];
